import React from 'react'
import { withRouter } from 'react-router-dom'
import { FramePage } from '../Frame/FramePage'
// policy
import file_haiou from '../../assets/file/privacypolicy_2023_09_26.htm'
import file_xiniu from '../../assets/xiniu/privacypolicy_2025_01_15.htm'
import file_xibei from '../../assets/xibei/privacypolicy_2025_01_15.htm'
import file_xbyg from '../../assets/xbyg/privacypolicy.htm'
import file_wanshun from '../../assets/wanshun/privacypolicy_2025_01_15.htm'
import file_youpin from '../../assets/youpin/privacypolicy.htm'
import file_qxtj from '../../assets/qxtj/privacypolicy.htm'
import file_qxyg from '../../assets/qxyg/privacypolicy.htm'
import file_qxdg from '../../assets/qxdg/privacypolicy.htm'
import file_tjyg from '../../assets/tjyg/privacypolicy_2025_03_25.htm'
// protocol
import policy_tradeasy from '../../assets/tradeasy/policyw_2024_7_3.htm'
import userAgreement_trading from '../../assets/trading/user_agreement_2025_06_06.htm'
import protocol_xibei from '../../assets/xibei/protocol.htm'
import protocol_xbyg from '../../assets/xbyg/protocol.htm'
import protocol_wanshun from '../../assets/wanshun/protocol_2024_10_24.htm'
import protocol_youpin from '../../assets/youpin/protocol.htm'
import protocol_qxtj from '../../assets/qxtj/protocol.htm'
import protocol_qxyg from '../../assets/qxyg/protocol.htm'
import protocol_qxdg from '../../assets/qxdg/protocol.htm'
import protocol_tjyg from '../../assets/tjyg/protocol_2025_03_25.htm'

// hnyt
import agreement_ytyg from '../../assets/hnyt/ytyg/user_agreement.htm'
import policy_ytyg from '../../assets/hnyt/ytyg/privacypolicy.htm'
import agreement_dyyg from '../../assets/hnyt/dyyg/user_agreement.htm'
import policy_dyyg from '../../assets/hnyt/dyyg/privacypolicy.htm'

let file = null // privacy_policy
let file_protocol = null
let urlPre = ''
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    file = file_haiou
    urlPre = 'http://cdn.bl.dev.seedtecgz.com'
    break
  case 'ytyg':
    file = policy_ytyg
    file_protocol = agreement_ytyg
    urlPre = 'http://h5.dev.yt.hnytysjs.com/ytyg'
    break;
  case 'dyyg':
    file = policy_dyyg
    file_protocol = agreement_dyyg
    urlPre = 'http://h5.dev.yt.hnytysjs.com/dyyg'
    break;
  case 'xbyg':
    file = file_xbyg
    file_protocol = protocol_xbyg
    urlPre = 'https://h5.hnqcwlkj.com'
    break;
  case 'xibei':
    file = file_xibei
    file_protocol = protocol_xibei
    urlPre = 'https://h5.hnqcwlkj.com'
    break;
  case 'xiniu':
    file = file_xiniu
    urlPre = 'https://h5.hnqcwlkj.com'
    break
  case 'wanshun':
    file = file_wanshun
    file_protocol = protocol_wanshun
    urlPre = 'https://h5.hnqcwlkj.com/wanshun'
    break;
  case 'youpin':
    file = file_youpin
    file_protocol = protocol_youpin
    urlPre = 'https://h5.hnqcwlkj.com/youpin'
    break;
  case 'qxyg':
    file = file_qxyg
    file_protocol = protocol_qxyg
    urlPre = 'https://h5.qxtj.hnjcwlkj.cn'
    break
  case 'qxtj':
    file = file_qxtj
    file_protocol = protocol_qxtj
    urlPre = 'https://h5.qxtj.hnjcwlkj.cn'
    break;
  case 'qxdg':
    file = file_qxdg
    file_protocol = protocol_qxdg
    urlPre = 'https://h5.qxtj.hnjcwlkj.cn'
    break
  case 'tjyg':
    file = file_tjyg
    file_protocol = protocol_tjyg
    urlPre = 'https://h5.qxtj.hnjcwlkj.cn'
    break
  case 'trading':
    file = ''
    // 这一块没有隐私协议
    file_protocol = userAgreement_trading
    urlPre = 'https://h5.trading.seedtecgz.com'
    break;
  case 'tradeasy':
    file = policy_tradeasy
    // 这一块还没给我
    file_protocol = protocol_xibei
    urlPre = 'https://h5.hnqcwlkj.com'
    break
  default:
}

const protocolMap = {
  '0': file,
  '1': `${urlPre}/files/privacypolicy.html`,
  '2': `${urlPre}/files/buy.html`,
  '3': `${urlPre}/files/sell.html`,
  '4': file_protocol,
  // '1': 'http://cdn.bl.dev.seedtecgz.com/files/privacypolicy.html',
  // '2': 'http://cdn.bl.dev.seedtecgz.com/files/buy.html',
  // '3': 'http://cdn.bl.dev.seedtecgz.com/files/sell.html'
}

@withRouter
class Protocol extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    // this.withHeader = urlParams.get('withHeader')
    this.code = urlParams.get('code') || '0'
  }

  componentDidMount () {
    let { title } = this.props.match.params
    if (title) {
      document.title = title
    }
  }

  render () {
    return <FramePage hideTitle title={''} src={protocolMap[this.code]}/>
  }
}

export default Protocol
